import { render, staticRenderFns } from "./_offre.vue?vue&type=template&id=487afd00"
import script from "./_offre.vue?vue&type=script&lang=js"
export * from "./_offre.vue?vue&type=script&lang=js"
import style0 from "./_offre.vue?vue&type=style&index=0&id=487afd00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderOffresDAlternance: require('/home/etienne/AM-frontend/components/HeaderOffresDAlternance.vue').default,ErrorFieldHandler: require('/home/etienne/AM-frontend/components/ErrorFieldHandler.vue').default,FormErrorPopUp: require('/home/etienne/AM-frontend/components/FormErrorPopUp.vue').default})
